import styled, { css } from 'styled-components';
import {
  MenuHouseIcon,
  MenuExitIcon,
  MenuSearchIcon,
  MenuUserIcon,
  MenuVdpIcon
} from '@carvana/purchase-icons';

export const Wrapper = styled.div`
  background-color: #36434c;
  color: #fff;
  position: absolute;
  width: 80%;
  height: 100%;
`;
export const ArrowLeft = styled.div`
  border-bottom: 8px solid transparent;
  border-right: 8px solid #f0f0f0;
  border-top: 8px solid transparent;
  height: 0;
  position: absolute;
  right: 0;
  top: 14px;
  width: 0;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;
export const ColumnLeft = styled.div`
  background-color: #2e393f;
  width: 25%;
`;
export const ColumnRight = styled.div`
  width: 75%;
`;
export const Row = styled.div``;
export const LeftIcons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 50%;

  @media (orientation: landscape) {
    height: 90%;
  }
`;

export const RightColumnText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: space-evenly;
  padding-left: 1rem;
  height: 50%;

  @media (orientation: landscape) {
    height: 90%;
  }
`;
export const Link = styled.a`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 28px;
  text-decoration: none;
  color: #fff;
`;

export const SvgIcon = css`
  height: 1.5rem;
  width: 1.5rem;
  fill: white;
`;
export const MenuHouse = styled(MenuHouseIcon)`
  ${SvgIcon}
`;
export const MenuVdp = styled(MenuVdpIcon)`
  ${SvgIcon}
`;
export const MenuSearch = styled(MenuSearchIcon)`
  ${SvgIcon}
`;
export const MenuUser = styled(MenuUserIcon)`
  ${SvgIcon}
`;
export const MenuExit = styled(MenuExitIcon)`
  ${SvgIcon}
`;
